import * as _ from 'lodash';

import { SelectConfig } from 'src/app/models/selectConfig';
import { FileAuditService } from './file-audit.service';
import { Component, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { ConfigurationCustomList } from 'src/app/models/configurationCustomList';
import { ModalConfig } from 'src/app/models/modalConfig';
import { ActionLine } from 'src/app/models/actionLine';
import { ParamsProcess } from 'src/app/views/pages/fileReturn/models/ParamsProcess';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountStatusLine } from 'src/app/models/countStatusLine';
import { ReturnElementCustomList } from 'src/app/models/ReturnElementCustomList';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Page } from 'src/app/models/page';
import { DatePipe } from '@angular/common';
import { FileService } from 'src/app/services/file.service';
import { ProcessLine } from '../models/processLine';
import { TranslateService } from '@ngx-translate/core';
import { TitleList } from 'src/app/components/custom-list/custom-list.component';
import { FileManageService } from '../file-manage/file-manage.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChangeStatusLineDialog } from './file-audit-changeStatusLineDialog/changeStatusLineDialog';

@Component({
    selector: 'kt-file-audit',
    templateUrl: './file-audit.component.html',
    styleUrls: ['./file-audit.component.scss'],
    providers: [DatePipe],
})
export class FileAuditComponent implements AfterViewInit, OnDestroy {
    informBatchParam: any;
    blockButton: Boolean;
    TotalFile: number;
    timer: NodeJS.Timeout;

    constructor(
        private activatedRoute: ActivatedRoute,
        private fileAuditService: FileAuditService,
        public loaderService: LoaderService,
        private spinner: NgxSpinnerService,
        private cdRef: ChangeDetectorRef,
        private notificationsService: NotificationsService,
        private fb: FormBuilder,
        private datePipe: DatePipe,
        private fileService: FileService,
        private _translate: TranslateService,
        private _fileManageService: FileManageService,
        private _dialog: MatDialog,
    ) {
        this.blockButton = false;
    }

    formDateAccounting: FormGroup;

    ngAfterViewInit(): void {
        let dateNow = new Date();

        this.formDateAccounting = this.fb.group({
            dateAccounting: {
                day: dateNow.getUTCDate(),
                year: dateNow.getUTCFullYear(),
                month: dateNow.getUTCMonth() + 1,
            },
        });

        this.loaderService.show();

        this.receivingBatchId = this.activatedRoute.snapshot.paramMap.get('id');
        this.statusBatch = this.activatedRoute.snapshot.paramMap.get('processStatusString');

        this.queryRecordedCharge = {
            params: {
                id: this.receivingBatchId,
                type: 0,
                limit: this.configTable.pageSize[0],
                skip: 0,
            },
        };

        this.getReceivingBatch(this.receivingBatchId);
    }

    ngOnDestroy(): void {
        clearTimeout(this.timer);
    }

    tableColsMockOk: boolean = false;
    disableSelectType: boolean = false;
    dataRecordedChargeOk: boolean = false;
    countStatusLine: CountStatusLine;
    tableDataMock: ResponseCustom;
    dataSaleOff: any;
    dataRecordedCharge;
    typeFilter: string = 'Pendency';
    countFinalize: boolean = false;
    returnElementCustomList: ReturnElementCustomList;
    valueSumForPage: number;
    receivingBatchId: string;
    loadingBatch: boolean = false;
    querySaleOff: any;
    queryRecordedCharge: any;
    statusBatch: string;

    page: Page = {
        totalElements: 0,
        index: 0,
        size: 0,
    };

    allTitleList: TitleList[] = [
        { colunName: 'numberLine', titleName: '' },
        { colunName: 'billetNumber', titleName: '' },
        { colunName: 'billetDueDate', titleName: '' },
        { colunName: 'creditDate', titleName: '' },
        { colunName: 'billetValue', titleName: '' },
        { colunName: 'valuePaid', titleName: '' },
        {
            colunName: 'difference',
            titleName: `Diferença" = Valor Pago - Valor 
        Valor positivo = Pago à Maior 
        Valor negativo = Pago à Menor`,
        },
        { colunName: 'error', titleName: '' },
        { colunName: 'listPossibleSolutions', titleName: '' },
        { colunName: 'lineStatusString', titleName: '' },
        { colunName: 'info', titleName: '' },
    ];

    titleListColunNames = this.allTitleList.map((x) => x.colunName);
    titleList = this.allTitleList.map((x) => x.titleName);

    tableColsMockRecordedCharge: string[] = [
        'numberLine',
        'billetNumber',
        'billetDueDate',
        'billetValue',
        'returnDate',
        'statusReturn',
        'lineStatus',
        'messages',
    ];

    actionLine: ActionLine = {
        status: true,
        typeActionLine: 'select',
        paramSelected: ['lineStatusString', 'Schedule', 'lineStatus.name'],
    };

    openbilletsFromResponsible: ModalConfig = {
        status: false,
        typeSolution: 0,
        element: {},
    };

    openDevolutionFromResponsible: ModalConfig = {
        status: false,
        typeSolution: 0,
        element: {},
        informBatch: {},
    };

    configSelect: SelectConfig = {
        nameProperties: ['number', 'description'],
        simbolDetach: '-',
        varResponse: 'solution',
    };

    configTable: ConfigurationCustomList = {
        tableTranslate: 'FILEAUDIT',
        searchField: false,
        typeField: {
            valuePaid: 'currency',
            iterestValue: 'currency',
            billetValue: 'currency',
            difference: 'currency',
            creditDate: 'date',
            returnDate: 'date',
            billetDueDate: 'date',
            listPossibleSolutions: 'select',
            error: 'replace',
            info: 'inform',
            messages: 'messages',
        },
        replaceValue: '-',
        selectConfig: this.configSelect,
        pageSize: [15, 20, 30],
        formatDate: 'dd/MM/yyyy',
        actionLine: this.actionLine,
        getSelected: false,
        page: this.page,
        tableName: 'saleOff',
        accounting: false,
        duplicate: false,
    };

    searchRecordedCharge = {
        billetNumber: null,
        billetDueDate: null,
        statusReturn: null,
        statusReturnLine: null,
        billetValue: null,
    };

    searchCountStatus = {
        billetNumber: null,
        billetDueDate: null,
        statusReturn: null,
        billetValue: null,
    };

    statusReturnList = [
        { id: '', description: 'Todos' },
        { id: 2, description: 'Confirmado' },
        { id: 3, description: 'Rejeitado' },
        { id: 9, description: 'Dispensado' },
        { id: 10, description: 'Outros' },
    ];

    statusReturnLine = [
        { id: '', description: this._translate.instant('STATUSRETURNLINE.all') },
        { id: 1, description: this._translate.instant('STATUSRETURNLINE.sheduled') },
        { id: 3, description: this._translate.instant('STATUSRETURNLINE.awaiting') },
        { id: 8, description: this._translate.instant('STATUSRETURNLINE.accounted') },
        { id: 0, description: this._translate.instant('STATUSRETURNLINE.standby') },
        { id: 2, description: this._translate.instant('STATUSRETURNLINE.enqueued') },
        { id: 7, description: this._translate.instant('STATUSRETURNLINE.deleted') },
        { id: 6, description: this._translate.instant('STATUSRETURNLINE.failed') },
        { id: 9, description: this._translate.instant('STATUSRETURNLINE.pendency') },
        { id: 4, description: this._translate.instant('STATUSRETURNLINE.proccessing') },
        { id: 5, description: this._translate.instant('STATUSRETURNLINE.success') },
    ];

    search() {
        this.queryRecordedCharge = {
            params: {
                id: this.receivingBatchId,
                type: 0,
                limit: this.configTable.pageSize[0],
                skip: 0,
                billetDueDate: '',
                billetNumber: '',
                statusReturn: '',
                statusReturnLine: '',
                billetValue: '',
            },
        };

        if (this.searchRecordedCharge.billetDueDate) {
            this.queryRecordedCharge.params.billetDueDate = this.datePipe.transform(
                this.searchRecordedCharge.billetDueDate,
                'yyyy-MM-dd',
            );
        }

        if (this.searchRecordedCharge.billetNumber) {
            this.queryRecordedCharge.params.billetNumber = this.searchRecordedCharge.billetNumber;
        }

        if (this.searchRecordedCharge.statusReturn) {
            this.queryRecordedCharge.params.statusReturn = this.searchRecordedCharge.statusReturn;
        }

        if (this.searchRecordedCharge.statusReturnLine) {
            this.queryRecordedCharge.params.statusReturnLine = this.searchRecordedCharge.statusReturnLine;
        }

        if (this.searchRecordedCharge.billetValue) {
            this.queryRecordedCharge.params.billetValue = parseFloat(
                this.searchRecordedCharge.billetValue.replace(',', '.'),
            );
        }

        this.getReceivingLinesRecordedCharge();
    }

    getReceivingBatch(batchId: string) {
        this.fileAuditService.getReceivingBacthForId(batchId).subscribe((receivingBatchSearch: ResponseCustom) => {
            if (receivingBatchSearch.typeResponse == 3) {
                this.configTable.accounting = receivingBatchSearch.data.processStatusId === 9;

                this.loaderService.hide();
                this.loadingBatch = true;
                this.informBatchParam = {
                    receivingBatchId: receivingBatchSearch.data.id,
                    fileName: receivingBatchSearch.data.fileName,
                    quantityLines: receivingBatchSearch.data.quantityLines,
                    date: receivingBatchSearch.data.date,
                    agreementCode: receivingBatchSearch.data.agreementCode,
                    valueTotal: receivingBatchSearch.data.valueTotal,
                    legalEntityDescription: receivingBatchSearch.data.legalEntityDescription,
                    legalEntityId: receivingBatchSearch.data.legalEntityId,
                };

                this.loadingTable(this.typeFilter);
                this.disableSelectType = false;
            }
        });
    }

    getListLinesSaleOff(params: any, totalStatus: number) {
        this.configTable.pageSize = [15, 20, 30];
        let index = this.configTable.pageSize.indexOf(totalStatus);

        if (index === -1) {
            this.configTable.pageSize.push(totalStatus);
        }

        this.configTable.page.totalElements = totalStatus;
        this.configTable.page.index = params.params.skip / params.params.limit;
        this.fileAuditService.getReceivingLinesSaleOff(params).subscribe((tableDataMock: ResponseCustom) => {
            if (['Succeeded', 'Enqueued', 'Processing'].includes(this.typeFilter)) {
                this.configTable.actionLine = {
                    status: false,
                };
            } else {
                this.configTable.actionLine = this.actionLine;
            }

            this.disableSelectType = false;
            this.tableColsMockOk = true;
            this.loaderService.hide();
            this.dataSaleOff = tableDataMock.data; //dados da linha
            this.dataSaleOff.forEach(function (item) {
                item.difference = item.valuePaid - item.billetValue;
            });

            if (this.dataSaleOff.length > this.configTable.pageSize[2]) {
                this.configTable.pageSize.push(this.dataSaleOff.length);
            }
            if (this.dataSaleOff.length == 0) {
                this.cdRef.detectChanges();
            }
        });
    }

    loadingTable(typeChange) {
        this.disableSelectType = true;
        this.tableColsMockOk = false;
        this.typeFilter = typeChange;

        this.querySaleOff = {
            params: {
                id: this.informBatchParam.receivingBatchId,
                type: 0,
                limit: this.configTable.pageSize[0],
                skip: 0,
                billetDueDate: '',
                billetNumber: '',
                statusReturn: '',
                billetValue: '',
            },
        };

        this.SearchInputCountStatus();

        switch (typeChange) {
            case 'Pendency':
                this.querySaleOff.params.type = 0;
                break;
            case 'StandBy':
                this.querySaleOff.params.type = 1;
                break;
            case 'Succeeded':
                this.querySaleOff.params.type = 2;
                break;
            case 'Enqueued':
                this.querySaleOff.params.type = 3;
                break;
            case 'Processing':
                this.querySaleOff.params.type = 4;
                break;
            case 'Failed':
                this.querySaleOff.params.type = 5;
                break;
        }

        this.loaderService.show();
        this.countFinalize = false;
        this.countStatus(typeChange, this.querySaleOff);
    }

    selectedLine(ev) {
        if (ev.length == 0) {
            this.notificationsService.warn('Selecione pelo menos um item para ser processado!');
            this.configTable.getSelected = false;
            return;
        }

        this.Process(ev);
    }

    countStatus(typeChange: string, query: any) {
        let search = {
            params: {
                receivingBatch: this.informBatchParam.receivingBatchId,
                billetDueDate: '',
                billetNumber: '',
                statusReturn: '',
                billetValue: '',
            },
        };

        this.SearchInputCountStatus;

        this.fileAuditService.countStatus(search).subscribe((result: any) => {
            this.countStatusLine = result.data;
            this.valueSumForPage = this.countStatusLine[`value${typeChange}`];
            this.countFinalize = true;
            let toLowerType = typeChange.charAt(0).toLowerCase() + typeChange.slice(1);
            let totalStatus = this.countStatusLine[toLowerType];
            this.TotalFile = this.calculeTotalLine(this.countStatusLine);
            this.getListLinesSaleOff(query, totalStatus);
            this.afterCountTimeOut(typeChange);
            this.cdRef.detectChanges();
        });
    }

    private ClearSearchCountStatusModel(): void {
        this.searchCountStatus.billetDueDate = null;
        this.searchCountStatus.billetNumber = null;
        this.searchCountStatus.statusReturn = null;
        this.searchCountStatus.billetValue = null;

        this.loadingTable(this.typeFilter);
    }

    private ClearSearchRecordedChargeModel(): void {
        this.searchRecordedCharge.billetDueDate = null;
        this.searchRecordedCharge.billetNumber = null;
        this.searchRecordedCharge.statusReturn = null;
        this.searchRecordedCharge.billetValue = null;
        this.searchRecordedCharge.statusReturnLine = null;

        this.search();
    }

    public SearchInputCountStatus(): void {
        if (this.searchCountStatus.billetDueDate) {
            this.querySaleOff.params.billetDueDate = this.datePipe.transform(
                this.searchCountStatus.billetDueDate,
                'yyyy-MM-dd',
            );
        }

        if (this.searchCountStatus.billetNumber) {
            this.querySaleOff.params.billetNumber = this.searchCountStatus.billetNumber;
        }

        if (this.searchCountStatus.statusReturn) {
            this.querySaleOff.params.statusReturn = this.searchCountStatus.statusReturn;
        }
        if (this.searchCountStatus.billetValue) {
            this.querySaleOff.params.billetValue = parseFloat(this.searchCountStatus.billetValue.replace(',', '.'));
        }
    }

    private afterCountTimeOut(type: string): void {
        switch (type) {
            case 'Enqueued':
                this.enqueueTimeOut();
                break;
            case 'Processing':
                this.processTimeOut();
                break;
        }
    }

    private enqueueTimeOut(): void {
        if (this.countStatusLine.enqueued > 0) {
            this.timer = setTimeout(() => {
                this.loaderService.hide();
                this.loadingTable('Enqueued');
            }, 3000);
        } else {
            this.loadingTable('Processing');
        }
    }

    private processTimeOut(): void {
        if (this.countStatusLine.processing > 0) {
            this.timer = setTimeout(() => {
                this.loaderService.hide();
                this.loadingTable('Processing');
            }, 3000);
        } else if (this.countStatusLine.failed > 0) {
            this.loadingTable('Failed');
        } else {
            this.loadingTable('Succeeded');
        }
    }

    Process(env) {
        this.createValueForSendProcess(env).then((processLines) => {
            let params: ParamsProcess = {
                processLines: processLines,
                typeProcess: 0,
                batchId: this.informBatchParam.receivingBatchId,
            };

            this.fileAuditService.sendReceivingLineFromProcess(params).subscribe((result) => {
                this.loaderService.hide();
                this.configTable.getSelected = false;
                this.loadingTable('Enqueued');
            });
        });
    }

    public ProcessAll(): void {
        this.loaderService.show();
        this.RegisteredChargeProcessAll();

        this.fileAuditService.processAll(this.informBatchParam.receivingBatchId).subscribe((result) => {
            if (result) {
                this.loaderService.hide();
                this.configTable.getSelected = false;
                this.loadingTable('Enqueued');
            }
        });
    }

    public RegisteredChargeProcessAll(): void {
        this.loaderService.show();
        this.blockButton = true;
        this.fileAuditService
            .RegisteredChargeProcessAll(this.informBatchParam.receivingBatchId, this.configTable.page.totalElements)
            .subscribe((result) => {
                if (result) {
                    this.loaderService.hide();
                    this.configTable.getSelected = false;
                    this.loadingTable('Enqueued');
                }
            });
    }

    changeLineStatus() {
        let lineSelected = this.dataSaleOff.filter((item) => item.lineStatusString === 'Schedule');

        if (lineSelected.length == 0) {
            this.notificationsService.warn('Não existem itens selecionados. Por favor selecione um ou mais itens!');
            return;
        }

        this.spinner.show();
        this.fileAuditService.checkPermissionToChangeStatusLine().subscribe((result) => {
            this.spinner.hide();

            if (result && result.data == true) {
                let lines = lineSelected.map((item) => item.numberLine);
                let messageText = `Alterar Status da(s) Linha(s) : ${lines.join(', ')} para :`;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.autoFocus = true;
                dialogConfig.minWidth = 400;
                dialogConfig.data = {
                    title: 'Selecione o Status da linha',
                    text: messageText,
                    selected: lineSelected,
                };
                const dialogRef = this._dialog.open(ChangeStatusLineDialog, dialogConfig);
                dialogRef.afterClosed().subscribe(() => {
                    this.refresh();
                });
            } else {
                this.notificationsService.warn(result.message);
            }
        });
    }

    save(paramType) {
        let lineUpdate;

        switch (paramType) {
            case 'All':
                lineUpdate = _.map(
                    _.filter(this.dataSaleOff, (x) => x.solution !== 0),
                    (x) => _.pick(x, ['id', 'solution', 'update', 'creditDate']),
                );

                if (lineUpdate.length == 0) {
                    this.notificationsService.warn(
                        'Não foram encontradas alterações. Por favor selecione ao menos uma solução para um item.',
                    );
                    return;
                }
                break;
            case 'Selected':
                lineUpdate = _.map(
                    _.filter(this.dataSaleOff, function (x) {
                        return x.solution !== 0 && x.lineStatusString === 'Schedule';
                    }),
                    (x) => _.pick(x, ['id', 'solution', 'update', 'creditDate']),
                );

                if (lineUpdate.length == 0) {
                    this.notificationsService.warn(
                        'Não existem itens selecionados. Por favor selecione um ou mais itens!',
                    );
                    return;
                }
                break;
        }

        lineUpdate[0].receivingBatchId = this.informBatchParam.receivingBatchId;
        this.spinner.show();
        this.fileAuditService.sendReceivingLineFromSave(lineUpdate).subscribe((result) => {
            this.spinner.hide();
            this.typeFilter = 'StandBy';
            this.loadingTable('StandBy');
        });
    }

    createValueForSendProcess(env) {
        return new Promise((resolve) => {
            var result = [];
            for (const key in env) {
                const element = env[key];

                let process: ProcessLine = {
                    lineId: element.id,
                    solution: element.solution,
                    lineStatus: element.lineStatusString,
                    billetIds: element.dataReceiving.map((x) => x.billetIdExternal),
                };

                result.push(process);
            }

            resolve(result);
        });
    }

    returnSelect(ev) {
        if (this.configTable.duplicate) {
            this.fileAuditService.DeleteDuplicateSaleOff(ev.id).subscribe((p) => {
                const result = p.data;
                if (result) {
                    this.notificationsService.success(
                        this._translate.instant('AUDITRETURNFILE.delete_with_successful'),
                    );
                    this.refresh();
                    this.configTable.duplicate = false;
                } else {
                    this.notificationsService.success(this._translate.instant('AUDITRETURNFILE.error_to_delete'));
                }
            });
        } else if (ev.action === 'refresh') {
            let receivingLineId = ev.element !== undefined ? ev.element.id : ev.id;
            this.fileAuditService.reloadReceivingLine(receivingLineId).subscribe(() => {
                this.refresh();
            });
            return;
        }
        switch (ev.typeSolution) {
            case 4:
                this.openBillets(ev);
                break;
            case 8:
                this.openDevolution(ev);
                break;
            default:
                this.returnElementCustomList = {
                    type: 0,
                    receivingLineId: ev.element !== undefined ? ev.element.id : ev.id,
                };

                this.onReturnElement(this.returnElementCustomList);

                break;
        }
    }

    openDevolution(param: ModalConfig) {
        this.openDevolutionFromResponsible = param;

        this.openDevolutionFromResponsible.informBatch = {
            legalEntityName: this.informBatchParam.legalEntityDescription,
            legalEntityId: this.informBatchParam.legalEntityId,
            agreementCode: this.informBatchParam.agreementCode,
        };
    }

    openBillets(param: ModalConfig) {
        this.openbilletsFromResponsible = param;
    }

    processSelected() {
        this.configTable.getSelected = true;
    }

    getListLinesRecordedCharge(ev) {
        if (ev.index === 1) {
            this.configTable.actionLine.status = false;
            this.configTable.pageSize = [15, 20, 30];
            this.configTable.tableName = 'recordedCharge';

            this.getReceivingLinesRecordedCharge();
        } else {
            this.configTable.actionLine.status = true;
        }
    }

    getReceivingLinesRecordedCharge() {
        this.loaderService.show();
        this.dataRecordedChargeOk = false;

        this.fileAuditService
            .getReceivingLinesRecordedCharge(this.queryRecordedCharge)
            .subscribe((tableDataMock: ResponseCustom) => {
                this.configTable.page.totalElements = tableDataMock.data.totalRecords;
                this.configTable.page.index =
                    this.queryRecordedCharge.params.skip / this.queryRecordedCharge.params.limit;
                this.loaderService.hide();
                this.dataRecordedCharge = tableDataMock.data.result;
                this.configTable.pageSize.push(this.configTable.page.totalElements);
                this.dataRecordedChargeOk = true;
                this.cdRef.detectChanges();
            });
    }
    calculeTotalLine(countStatusLine: CountStatusLine): number {
        let total =
            countStatusLine?.valuePendency +
            countStatusLine?.valueProcessing +
            countStatusLine?.valueFailed +
            countStatusLine?.valueSucceeded +
            countStatusLine?.valueStandBy;
        return total;
    }

    onReturnElement(ev) {
        let positionElement = this.dataSaleOff.map((x) => x.id).indexOf(ev.receivingLineId);

        if (ev.clear && ev.clear == true) {
            this.dataSaleOff[positionElement][this.configSelect.varResponse] = 0;
        } else {
            this.dataSaleOff[positionElement]['update'] = ev;
        }

        if (ev.type === 2) {
            this.dataSaleOff[positionElement]['devolutionLine'] = {
                accountingGroupName: ev.devolution.serveGroupSelectedName,
                dateDevolution: ev.devolution.dateDevolution,
                legalEntityId: ev.devolution.legalEntityId,
            };
        } else if (ev.type === 1) {
            this.dataSaleOff[positionElement].dataReceiving = [];
            for (let index = 0; index < ev.descriptionBillets.length; index++) {
                const element = ev.descriptionBillets[index];
                this.dataSaleOff[positionElement].dataReceiving.push({
                    billetNumber: element.number,
                    billetIdExternal: element.billetIdExternal,
                });
            }
        }
    }

    refresh() {
        this.loadingTable(this.typeFilter);
    }

    cleanFilter(search) {
        if (search == 'searchRecordedCharge') {
            this.ClearSearchRecordedChargeModel();
        } else {
            this.ClearSearchCountStatusModel();
        }
    }

    Accounting() {
        this.spinner.show();

        const dateAccount = this.datePipe.transform(
            `${this.formDateAccounting.value.dateAccounting.year}-${this.formDateAccounting.value.dateAccounting.month}-${this.formDateAccounting.value.dateAccounting.day}`,
            'yyyy/MM/dd',
        );

        this.fileAuditService.accountBatch(this.informBatchParam.receivingBatchId, dateAccount).subscribe((result) => {
            if (result.typeResponse == 3) {
                this.spinner.hide();
                this.configTable.accounting = true;
                this.notificationsService.success('Contabilização realizada com sucesso');
            }
        });
    }

    reloadingForAction(ev) {
        switch (ev.tableName) {
            case 'saleOff':
                this.disableSelectType = true;
                this.tableColsMockOk = false;
                this.querySaleOff.params.skip = ev.pageIndex * ev.pageSize;
                this.querySaleOff.params.limit = ev.pageSize;
                this.configTable.page.size = ev.pageSize;
                this.countStatus(this.typeFilter, this.querySaleOff);
                break;
            case 'recordedCharge':
                this.dataRecordedChargeOk = false;
                this.queryRecordedCharge.params.skip = ev.pageIndex * ev.pageSize;
                this.queryRecordedCharge.params.limit = ev.pageSize;
                this.configTable.page.size = ev.pageSize;
                this.getListLinesRecordedCharge({ index: 1 });
                break;
            default:
                break;
        }
    }

    public queueToStandBy() {
        this.fileAuditService.QueueToStandBy(this.receivingBatchId).subscribe((result) => {
            this.refresh();
        });
    }
    public processingToStandBy() {
        this.fileAuditService.ProcessingToStandBy(this.receivingBatchId).subscribe((result) => {
            this.refresh();
        });
    }

    public downloadFile() {
        this.spinner.show();
        let fileName = this.informBatchParam.fileName;
        let legalEntityId = this.informBatchParam.legalEntityId;
        this._fileManageService.DownloadFile(legalEntityId, fileName).subscribe((result) => {
            this.fileService.downloadFile(result);
            this.spinner.hide();
        });
    }

    financialReport() {
        this.spinner.show();

        this.fileAuditService.financialReport(this.receivingBatchId).subscribe({
            next: (response: Blob) => {
                this.spinner.hide();

                const blob = new Blob([response], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            },

            error: (error) => {
                this.spinner.hide();

                if (error.status === 400) {
                    const reader = new FileReader();

                    reader.onload = () => {
                        const message = reader.result as string;

                        alert(message);
                    };

                    reader.readAsText(error.error);
                }
            },
        });
    }

    public exportReceivingLines() {
        this.spinner.show();
        this.fileAuditService.exportReceivingLines(this.receivingBatchId).subscribe({
            next: (res) => {
                this.fileService.downloadFile(res);
                this.spinner.hide();
            },
            error: (err) => {
                this.spinner.hide();
            },
        });
    }
}
